import {FC} from 'react';
import {DescriptionOutlined} from '@mui/icons-material';
import {Box} from '@mui/material';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {PhoneCardHead} from 'src/components/mobile/PhoneCardHead';
import {PhoneCardFacts} from 'src/components/mobile/PhoneCardFacts';
import {phonePillsRowSx} from 'src/components/mobile/mobileDesign.sx';
import {TableCard} from '../../../tables/respnsiveTable/TableCard';
import {titleLinkSx} from './ContractHistoryCard.sx';
import {ContractHistoryCardProps} from './ContractHistoryCard.types';

export const ContractHistoryCard: FC<ContractHistoryCardProps> = ({
                                                                      name,
                                                                      link,
                                                                      created,
                                                                      signed,
                                                                      archived,
                                                                      status,
                                                                      operation,
                                                                  }) => {
    return (
        <TableCard>
            <PhoneCardHead
                icon={<DescriptionOutlined/>}
                title={(
                    <Box
                        component={Link}
                        to={link}
                        sx={titleLinkSx}
                    >
                        {name}
                    </Box>
                )}
            />
            {/* The page's own status pill, with the colours it already carries. */}
            <Box sx={phonePillsRowSx}>{status}</Box>
            <PhoneCardFacts
                facts={[
                    {label: <FormattedMessage id="createdOnColumnHeader"/>, value: created},
                    {label: <FormattedMessage id="signedOn"/>, value: signed},
                    {label: <FormattedMessage id="operation"/>, value: operation},
                    {label: <FormattedMessage id="archived"/>, value: archived},
                ]}
            />
        </TableCard>
    );
};
